"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userHome = exports.defaultFolderItemTitles = exports.allMyContent = void 0;
var allMyContent = [{
  id: "allmycontent",
  title: "All My Content"
}];
exports.allMyContent = allMyContent;
var userHome = [{
  id: "root",
  title: ""
}];
exports.userHome = userHome;
var defaultFolderItemTitles = [].concat(allMyContent, userHome);
exports.defaultFolderItemTitles = defaultFolderItemTitles;